import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Container, Typography } from '@material-ui/core'
import { Link } from 'react-router-dom'

const useStyles = makeStyles(theme => ({
  root: {
    padding: '10px'
  },
  link: {
    'text-decoration': 'none'
  },
  contentHeader: {
    marginTop: '70px',
    marginBottom: '15px'
  },
  contentBody: {
    marginBottom: '50px'
  }
}))

export const Content = (props) => {
  const classes = useStyles()

  return (
    <Container className={classes.root}>
      <Typography
        variant='h1' align='center'
        className={classes.contentHeader}
      >お問い合わせありがとうございます
      </Typography>
      <Typography variant='body1' align='center' className={classes.contentBody}>
        お問い合わせを受け付けました。<br />
        企業担当者よりご連絡を差し上げますのでしばらくお待ちください。
      </Typography>
      <Typography variant='body1' align='center' className={classes.contentBody}>
        <Link className={classes.link} to='/'>
          トップに戻る
        </Link>
      </Typography>
    </Container>
  )
}
